module.exports = __webpack_public_path__ + "img/qr-code.7c0aadab.svg";